import { render, staticRenderFns, recyclableRender, components } from "./u-upload.vue?vue&type=template&id=69e2a36e&scoped=true&"
var renderjs
import script from "./u-upload.vue?vue&type=script&lang=js&"
export * from "./u-upload.vue?vue&type=script&lang=js&"
import style0 from "./u-upload.vue?vue&type=style&index=0&id=69e2a36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e2a36e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-upload/u-upload.vue"
export default component.exports